<dx-box width="100%" height="100%" direction="row">
    <ng-container *ngFor="let breadCrumb of breadCrumbs; let idx = index">
        <dxi-item baseSize="auto">
            <div *dxTemplate>
                <div class="bread-crumb-container">
                    <div class="bread-crumb" [ngClass]="{ 'cc-highlight-row': breadCrumb.isDefault }">
                        {{ breadCrumb.displayText }}
                    </div>
                    <div class="bread-crumb-help">
                        <i class="dx-theme-accent-as-text-color" [ngClass]="iconHelp"></i>
                    </div>
                    <div *ngIf="idx !== breadCrumbs.length - 1" class="bread-crumb-next-level">
                        <i [ngClass]="iconNext"></i>
                    </div>
                </div>
            </div>
        </dxi-item>
    </ng-container>
</dx-box>
